export const palette = {
  black: "#1d1d1d",
  white: "#ffffff",
  white20: "rgba(255, 255, 255, 0.2)",
  white50: "rgba(255, 255, 255, 0.5)",
  offWhite: "#e6e6e6",
  orange: "#FF8B22",
  orangeDarker: "#EB9918",
  lightGrey: "#939AA4",
  lighterGrey: "#CDD4DA",
  angry: "#dd3333",
  deepPurple: "#5D2555",
  blue: "#001B53",
  blue10P: "rgba(0, 27, 83, 0.1)",
  blue20P: "rgba(0, 27, 83, 0.2)",
  blue5P: "rgba(0, 27, 83, 0.05)",
  blue40P: "rgba(0, 27, 83, 0.4)",
  blue60P: "rgba( 0, 27, 83,  0.6)",
  blueTrans: "rgba(0, 27, 83, 0.4)",
  blue005: 'rgba(0, 27, 83, 0.05)',
  orangeTrans: "rgba(255, 139, 34, 0.6)",
  orange20P: "rgba(255, 139, 34, 0.2)",
  orange80P: "rgba(255, 139, 34, 0.8)",
  red: "#E84C3D",
  red05:'rgba(232, 76, 61, 0.05)',
  green05:"rgba(30, 164, 95, 0.05)",
  redTrans: "#FEF6F5",
  green: "#1EA45F",
  green10P: "rgba(30, 164, 95, 0.1)",
  greenTrans: "rgba(30, 164, 95, 0.1)",
  grey: "#272A32",
  grey80P: "#4E5461",
  grey60P: "#9297A2",
  grey40P: "#D0D3D9",
  grey20P: "#EEEFF2",
  grey10P: "#F6F7F9",
  blueBorder: "#7B61FF",
  blue80p: "rgba(0, 27, 83, 0.8)",
  scrim: "rgba(19, 34, 66, 0.6)",
  black40:"rgba(39, 42, 50, 0.4)",
  blackTrans: "rgba(39, 42, 50, 0.05)",
  blueSecondary: "#F2F4F6",
  babyBlue: "#B6E0EC",
  screenOpacity: "rgba(19, 34, 66, 0.6)",
  blueSecondaryBorder: "rgba(0, 27, 83, 0.05)",
  shadowColor: "rgba(0, 27, 83, 0.04)",
  orangeDisabled: "rgba(255, 139, 34, 0.3)",
  greyDisabled: "rgba(238,239,242, 0.3)",
  lightRedWhiteGradient: "linear-gradient(0deg, rgba(232, 76, 61, 0.05), rgba(232, 76, 61, 0.05)",
  welcomeScreenGradient: "linear-gradient(180deg, rgba(0, 27, 83, 0.4) 18.75%, rgba(0, 11, 33, 0.9)",
  white_shadow: '#F7F8FA',
  cobaltBlue:"#1c6acf",
  cobaltBlue02: "rgba(28, 106, 207, 0.2)",

}
